import * as React from 'react';
import { AnsweredQuestionnaireDto } from '../../../pages/answeredQuestionnaireTypes';
import { downloadPdf } from '../../../pages/assessment/questionnaireApi';
import { Theme, WithStyles } from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -theme.spacing.unit * 2,
    marginLeft: -theme.spacing.unit * 2
  }
});


export interface Props extends WithStyles<typeof styles> {
  questionnaire: AnsweredQuestionnaireDto,
}

function AnsweredQuestionnaireListMenu(props: Props) {
  const [loading, setLoading] = React.useState(false);

  function getDownloadIcon() {
    return <SvgIcon>
      <path fill="#000000" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"/>
    </SvgIcon>;
  }

  return (
    <Button
      onClick={() => download(props.questionnaire)}
      disabled={loading}
    >
      {loading ? (
          <CircularProgress size={32} className={props.classes.buttonProgress}/>
        ) :
        getDownloadIcon()
      }
    </Button>
  );

  function download(answeredQuestionnaireDto: AnsweredQuestionnaireDto) {
    setLoading(true);
    downloadPdf(answeredQuestionnaireDto.id).then(
      blob => {
        setLoading(false);
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob)
        } else {
          const link = document.createElement('a');
          if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', getPdfName(answeredQuestionnaireDto));
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

          }
        }
      }
    )
  }

  function getPdfName(answeredQuestionnaireDto: AnsweredQuestionnaireDto): string {
    const employee = answeredQuestionnaireDto.appraisee;
    return `${employee.firstName}-${employee.lastName}-${answeredQuestionnaireDto.endDate}.pdf`
  }
}

export default withStyles(styles)(AnsweredQuestionnaireListMenu);
